import s from './footer.module.scss';
import FooterLinks from '@/ui/footer-links/footer-links';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';

import dynamic from 'next/dynamic';

const FooterSocialLinks = dynamic(() => import('./social-links/social-links'));

const Footer = () => {
  const t = useTranslations('Common');
  const { pathname } = useRouter();

  const isContactsPage = pathname === '/contacts';

  return (
    <>
      {isContactsPage && <FooterSocialLinks />}

      <footer className={s.footer}>
        <div className="container">
          <div className={s.flexDesk}>
            <div className={s.maxW}>
              <img
                src="/icons/logoLight.svg"
                className={s.logo}
                alt="IMEI.BEST"
                width={167}
                height={40}
                loading="lazy"
              />
            </div>

            <div className={s.links}>
              <FooterLinks />
            </div>

            <p className={s.copy}>
              {t('copyrights', { year: new Date().getFullYear() })}
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
